import { render } from "./autocomplete-select.vue?vue&type=template&id=1331ac2e&ts=true"
import script from "./autocomplete-select.ts?vue&type=script&lang=ts"
export * from "./autocomplete-select.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__